<template>
  <v-card height="100%" class="px-2">
    <v-card-title> Company {{ t("core_values.title") }} </v-card-title>
    <v-card-subtitle>
      Manage and monitor your companies {{ t("core_values.title") | lower }}
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-slide-group show-arrows>
            <v-slide-item>
              <v-avatar
                class="border--question border--dashed border--2 mr-4 cursor-pointer"
                size="100"
                @click="$router.push({ path: '/core-values/add' })"
              >
                <v-icon size="70" color="lighttext">add</v-icon>
              </v-avatar>
            </v-slide-item>
            <v-slide-item v-for="(item, i) in coreValues" :key="i" v-slot="{}">
              <avatar
                v-on:click="$router.push({ path: '/core-values/' + item.id })"
                size="100"
                cssClass="mr-4 text-h3 cursor-pointer"
                :badgeUrl="item.badgeUrl"
                :fill="$vuetify.theme.themes.light.secondary"
              >
                <template v-slot:tooltip>
                  {{ item.name }}
                </template>
              </avatar>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="coreValues"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
            @click:row="rowClick"
            class="row-pointer"
          >
            <template v-slot:item.behaviorCount="{ item }">
              <v-btn
                small
                outlined
                color="secondary"
                v-if="item.behaviors.length == 0 && is_admin"
                :to="'/core-values/' + item.id"
              >
                Add
              </v-btn>
              <template v-else>
                {{ item.behaviors.length }}
              </template>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                text
                class="light-background"
                small
                color="info"
                :to="'/core-values/' + item.id"
              >
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CoreValuesCard",
  components: {},
  data: () => ({
    loading: false
  }),
  computed: {
    headers() {
      return [
        { text: "Name", value: "name" },
        {
          text: this.t("core_values.behavior_title"),
          value: "behaviorCount",
          align: "center"
        },
        { text: "Details", value: "actions", sortable: false, align: "right" }
      ];
    },
    ...mapGetters({
      coreValues: "company/coreValues",
      is_admin: "profile/is_admin"
    })
  },
  created() {},
  methods: {
    rowClick(item) {
      this.$router.push({ path: "/core-values/" + item.id });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__wrapper {
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>
